import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useCreditCardPaymentSchema = () => {
  const yupValidators = useYupValidators();
  const creditCardPaymentSchema = yup.object().shape({
    cardHolder: yupValidators.cardHolder,
    cardNumber: yupValidators.cardNumber,
    // yupValidators.genericRequiredNumber({
    //   message: t('creditCardPaymentSchema:enterYourCardNumber'),
    //   min: 16,
    //   max: 24,
    // }),,
    expirationDate: yupValidators.expirationDate,
    cvv: yupValidators.cvv,
  });

  return { creditCardPaymentSchema };
};

export { useCreditCardPaymentSchema };
